import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Beer, Truck, Flame, Crown, ArrowRight } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1537290946-0a1420e210dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  return (
    <div className="min-h-screen" data-testid="about-page">
      {/* Hero */}
      <section className="relative min-h-[60vh] grain overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0E0B]/80 via-[#0A0E0B]/85 to-[#0A0E0B]" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 py-20 md:py-28">
          <div className="font-anton uppercase tracking-[0.3em] text-[#DD5422] text-sm mb-3">/ The Story</div>
          <h1 className="font-anton text-5xl md:text-8xl uppercase tracking-tighter">Built On <span className="text-[#DD5422]">Back Roads</span>.</h1>
          <p className="text-lg md:text-xl text-[#8D9688] mt-8 max-w-2xl leading-relaxed">
            Everythang Redneck ain't a brand, it's a way of living. We started this for the folks who'd rather spend Saturday on the four-wheeler than the couch — for the tailgates that turn into bonfires, the trucks that ain't never gettin' washed, and the country girls who can outshoot their boyfriends.
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            { icon: Truck, title: "American Made", body: "Designs printed in-house. Heavy cotton. Built to outlast the truck." },
            { icon: Beer, title: "No Apologies", body: "We love beer, mud, and the South. Ain't changin' for nobody." },
            { icon: Flame, title: "Real Folks", body: "Designed by country folks for country folks. No corporate fluff." },
            { icon: Crown, title: "VIP Loyalty", body: "Our crew gets drops first. Always 10% off. Members-only videos." },
          ].map((v) => (
            <div key={v.title} className="border-2 border-[#2C332A] p-6 hover:border-[#DD5422] transition-colors">
              <v.icon className="w-8 h-8 text-[#DD5422] mb-4" strokeWidth={1.5} />
              <div className="font-anton text-xl uppercase tracking-tight">{v.title}</div>
              <p className="text-sm text-[#8D9688] mt-2">{v.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-5xl mx-auto px-4 md:px-8 pb-20">
        <div className="bg-[#DD5422] p-10 md:p-16 text-center">
          <h2 className="font-anton text-4xl md:text-6xl uppercase tracking-tight text-[#0A0E0B]">Y'all Ready?</h2>
          <p className="text-[#0A0E0B]/90 mt-4 max-w-xl mx-auto">Saddle up. Grab a tee. Crank the speakers. Welcome to the family.</p>
          <Link to="/shop" className="inline-block mt-8">
            <Button className="bg-[#0A0E0B] text-[#DD5422] hover:bg-[#151A14] hover:text-[#FF6B35] rounded-none font-anton uppercase tracking-widest h-14 px-8 text-base border-2 border-[#0A0E0B]">
              Shop The Drop <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
